var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6854_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9981 11.5499C22.9993 11.3649 22.9064 11.1928 22.7531 11.0961H22.7504L22.7408 11.0906L14.771 6.23964C14.7366 6.21573 14.7009 6.19387 14.6641 6.17419C14.3563 6.01095 13.9908 6.01095 13.6831 6.17419C13.6462 6.19389 13.6105 6.21573 13.5761 6.23964L5.60636 11.0906L5.59674 11.0961C5.35316 11.2519 5.27848 11.5812 5.42995 11.8317C5.47458 11.9055 5.53605 11.9669 5.60903 12.0108L13.5788 16.8618C13.6133 16.8855 13.649 16.9073 13.6858 16.9272C13.9935 17.0905 14.359 17.0905 14.6668 16.9272C14.7035 16.9073 14.7392 16.8855 14.7737 16.8618L22.7435 12.0108C22.9027 11.9153 22.9999 11.7394 22.9981 11.5499Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53697 8.31105H11.7671V13.2407H6.53697V8.31105ZM21.9299 3.3V1.04499C21.9424 0.481192 21.5084 0.01351 20.9601 0H7.38798C6.83968 0.01351 6.40567 0.481192 6.41823 1.04499V3.3L14.4415 5.49999L21.9299 3.3Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41797 3.2998H11.7668V8.2498H6.41797V3.2998Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1145 3.2998H11.7656V8.2498L17.1145 13.1998H21.9284V8.2498L17.1145 3.2998Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7656 8.25H17.1145V13.2H11.7656V8.25Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7656 13.2002H17.1145V18.1502H11.7656V13.2002Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53906 13.2407H11.7692V17.7221H6.53906V13.2407Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1172 13.2002H21.9311V18.1502H17.1172V13.2002Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7538 11.9805L22.7437 11.986L14.7739 16.595C14.7391 16.6169 14.7038 16.6378 14.6669 16.6565C14.5316 16.7228 14.3845 16.7602 14.2347 16.7666L13.7993 16.5047C13.7626 16.4858 13.7268 16.4646 13.6924 16.4415L5.61563 11.7016H5.61189L5.34766 11.5498V20.88C5.35178 21.5025 5.84573 22.0038 6.45112 21.9998H21.9125C21.9215 21.9998 21.9296 21.9954 21.9392 21.9954C22.0671 21.987 22.1931 21.9599 22.3136 21.9151C22.3657 21.8924 22.4159 21.8656 22.4639 21.8348C22.4997 21.8139 22.5613 21.7683 22.5613 21.7683C22.8353 21.5598 22.9974 21.2305 22.9988 20.88V11.5498C22.9986 11.7283 22.905 11.8928 22.7538 11.9805Z",
    fill: "url(#paint0_linear_6854_41)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.5706 11.513V12.085L14.2372 17.9848L5.60947 11.7055C5.60947 11.7025 5.60707 11.7 5.60412 11.7L4.8125 11.2105V10.798L5.13878 10.7925L5.82877 11.1995L5.84481 11.205L5.90365 11.2435C5.90365 11.2435 14.0125 16.001 14.0339 16.012L14.3441 16.199C14.3708 16.188 14.3976 16.177 14.4297 16.166C14.4457 16.155 22.4797 11.5075 22.4797 11.5075L22.5706 11.513Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7538 11.9805L22.7437 11.9865L14.7739 16.5955C14.7391 16.6175 14.7038 16.6384 14.6669 16.6571C14.3574 16.8126 13.9954 16.8126 13.6859 16.6571C13.6493 16.6384 13.6136 16.6179 13.579 16.5955L5.60921 11.9865L5.59959 11.9805C5.44572 11.8947 5.34925 11.7298 5.34766 11.5498V20.88C5.35149 21.5024 5.84527 22.0037 6.45054 21.9998C6.45054 21.9998 6.45056 21.9998 6.45059 21.9998H21.8959C22.5012 22.0038 22.9949 21.5024 22.9988 20.88C22.9988 20.88 22.9988 20.88 22.9988 20.88V11.5498C22.9986 11.7283 22.905 11.8928 22.7538 11.9805Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.8928 16.5273L14.7735 16.5961C14.7389 16.6187 14.7032 16.6395 14.6665 16.6582C14.5351 16.7246 14.3922 16.7635 14.2461 16.7726L17.2783 20.4598L22.5678 21.7705C22.7128 21.6579 22.828 21.5099 22.9032 21.3398L14.8928 16.5273Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M15.433 16.2148L14.7735 16.596C14.7389 16.6186 14.7032 16.6394 14.6665 16.6581C14.5351 16.7245 14.3922 16.7634 14.2461 16.7725L15.6667 20.8002L22.5694 21.7687C22.8413 21.5588 23.0014 21.2296 23.0016 20.8799V20.7595L15.433 16.2148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46556 21.9998H21.8943C22.1317 22.001 22.3632 21.9239 22.5548 21.7798L13.7988 16.5059C13.762 16.4869 13.7263 16.4658 13.6918 16.4426L5.61509 11.7027H5.61135L5.34766 11.5498V20.8481C5.34705 21.4836 5.84755 21.9992 6.46556 21.9998Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.836 5.40805V17.1395C12.8351 17.5509 12.5918 17.9206 12.2209 18.0745C12.106 18.1253 11.9823 18.1515 11.8572 18.1516H5.34766V4.9499H6.41743V4.3999H11.8572C12.3976 4.40201 12.8349 4.85241 12.836 5.40805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.3011 5.9579V17.6894C12.3025 17.8222 12.2751 17.9538 12.2209 18.0744C12.0724 18.4509 11.7174 18.6979 11.3223 18.6997H5.34766V4.94975H11.3223C11.4775 4.94815 11.6305 4.98796 11.7663 5.06526C12.0941 5.23512 12.301 5.58038 12.3011 5.9579Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.3011 5.9579V16.5894C12.2985 17.1448 11.8624 17.5949 11.3223 17.5997H5.34766V4.94975H11.3223C11.4775 4.94815 11.6305 4.98796 11.7663 5.06526C12.0941 5.23512 12.301 5.58038 12.3011 5.9579Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.7663 5.95834V16.5898C11.7657 17.1461 11.3284 17.5975 10.7874 17.6002H5.34766V4.9502H10.7874C11.3283 4.95049 11.7665 5.40162 11.7662 5.9578C11.7663 5.95798 11.7663 5.95816 11.7663 5.95834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.980438 4.9502H10.787C11.3285 4.9502 11.7674 5.40157 11.7674 5.95834V16.042C11.7674 16.5988 11.3285 17.0502 10.787 17.0502H0.980438C0.438952 17.0502 0 16.5988 0 16.042V5.95834C0 5.40157 0.438964 4.9502 0.980438 4.9502Z",
    fill: "url(#paint1_linear_6854_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.06453 9.17858C3.30618 8.64918 3.69622 8.20616 4.18458 7.90643C4.72542 7.58804 5.3412 7.42932 5.96414 7.44773C6.5415 7.43485 7.11121 7.58534 7.61105 7.88277C8.081 8.17095 8.4595 8.59319 8.7006 9.09827C8.96317 9.65481 9.09403 10.2673 9.08251 10.8858C9.09524 11.5321 8.9606 12.1725 8.68937 12.7558C8.44253 13.2789 8.05202 13.7162 7.56612 14.0136C7.04701 14.3202 6.45615 14.4746 5.8577 14.4602C5.26801 14.4748 4.68574 14.3226 4.17442 14.0202C3.7004 13.7317 3.31715 13.3089 3.07042 12.8025C2.80629 12.254 2.67388 11.6484 2.68424 11.0365C2.67323 10.3956 2.80324 9.7605 3.06453 9.17858ZM4.25839 12.1651C4.38723 12.4997 4.60571 12.79 4.88848 13.0022C5.1765 13.2092 5.52138 13.3159 5.87266 13.3069C6.24676 13.3221 6.61551 13.2117 6.92318 12.9923C7.20237 12.7808 7.41511 12.4897 7.53508 12.1552C7.66919 11.7815 7.73537 11.3857 7.73031 10.9875C7.73446 10.5855 7.67224 10.1857 7.54631 9.80502C7.43508 9.46137 7.2292 9.15834 6.95366 8.93272C6.65371 8.70295 6.28595 8.58641 5.91224 8.60273C5.55335 8.59317 5.20074 8.70079 4.90506 8.91017C4.61751 9.12323 4.39488 9.41606 4.2632 9.75442C3.9711 10.53 3.96958 11.3895 4.25892 12.1662L4.25839 12.1651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1172 3.2998H21.9311V8.2498H17.1172V3.2998Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6854_41",
    x1: 14.1732,
    y1: 11.5498,
    x2: 14.1732,
    y2: 21.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6854_41",
    x1: 2.04424,
    y1: 4.16245,
    x2: 10.0486,
    y2: 17.6447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6854_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.2ea718da689cfe5885b4623d83cc7ffa.svg";
export { ForwardRef as ReactComponent };